import { transformErrorResponse } from "../../transformErrorResponse"
import { BantelENTITY, FilesDocDTO } from "sigo-entities"
import { AtcApiBuilder } from "."

export const PERU_9112_BantelOrder = (build: AtcApiBuilder) => {
    return {
        getByIdBantelOrders: build.query<BantelENTITY[], string>({
            query: (userId) => `procesos/PERU_9112_BantelOrder/${userId}`,
            providesTags: (result, error, userId) =>
                result
                    ? [
                        // tag individual por cada orden
                        ...result.map((order) => ({
                            type: 'BantelOrders' as const,
                            id: order._id,
                        })),
                        // y un tag general de la lista de ese usuario
                        { type: 'BantelOrders' as const, id: `USER-${userId}` },
                    ]
                    : [{ type: 'BantelOrders' as const, id: `USER-${userId}` }],
            transformErrorResponse
        }),
        getTransitBantelOrders: build.query<{ transito: number }, { id_recurso: string, codigo: number }>({
            query: ({ id_recurso, codigo }) => `procesos/PERU_9112_BantelOrder/calculate-transit/${id_recurso}/${codigo}`,
            transformErrorResponse
        }),
        addInventoryBantelOrders: build.mutation<BantelENTITY, { id: string, body: { ID_StockPersonal: number, cantidad: number, Serie?: { Serie: string, ID_StockPersonalEquipos: number } } }>({
            query: ({ body, id }) => ({
                url: `procesos/PERU_9112_BantelOrder/add-inventory/${id}`,
                method: "PUT",
                body,
            }),
            invalidatesTags: (result, error, { id }) => [
                { type: 'BantelOrders' as const, id },
            ],
            transformErrorResponse
        }),
        deleteInventoryBantelOrders: build.mutation<BantelENTITY, { id: string, codigo: number, serie: string }>({
            query: ({ id, codigo, serie }) => ({
                url: `procesos/PERU_9112_BantelOrder/delete-inventory/${id}/${codigo}?serie=${serie}`,
                method: "PUT",
            }),
            invalidatesTags: (result, error, { id }) => [
                { type: 'BantelOrders' as const, id },
            ],
            transformErrorResponse
        }),
        finalizeBantelOrders: build.mutation<BantelENTITY, { id: string }>({
            query: ({ id }) => ({
                url: `procesos/PERU_9112_BantelOrder/finalize/${id}`,
                method: "PUT"
            }),
            invalidatesTags: (result, error, { id }) => [
                // invalida la orden puntual
                { type: 'BantelOrders' as const, id },
                // y también la lista del usuario (para que se refresque)
                // { type: 'WINOrders' as const, id: `USER-${userId}` },
            ],
            transformErrorResponse
        }),
        uploadPhotosBantelOrders: build.mutation<BantelENTITY, { id: string, boletin: FilesDocDTO }>({
            query: ({ boletin, id }) => ({
                url: `procesos/PERU_9112_BantelOrder/upload-files/${id}`,
                method: "PUT",
                body: { boletin },
            }),
            invalidatesTags: (result, error, { id }) => [
                { type: 'BantelOrders' as const, id },
            ],
            transformErrorResponse
        }),
    }
}